import { requestRaw } from './request'

function normalizeBaseUrl(value) {
  return String(value || '').trim().replace(/\/+$/, '')
}

function joinUrl(base, path) {
  if (!base) return path
  if (!path) return base
  if (base.endsWith('/') && path.startsWith('/')) return `${base.slice(0, -1)}${path}`
  if (!base.endsWith('/') && !path.startsWith('/')) return `${base}/${path}`
  return `${base}${path}`
}

function normalizeUploadPath(value) {
  return String(value || '').replace(/^\/+/, '')
}

function extractUploadedItems(result = {}) {
  const payload = result?.data ?? result
  if (Array.isArray(payload)) return payload
  if (payload && typeof payload === 'object') return [payload]
  return []
}

function extractUploadedPath(item = {}) {
  const path = item?.path ?? item?.url
  return path ? normalizeUploadPath(path) : ''
}

const STATIC_BASE = normalizeBaseUrl(
  process.env.VUE_APP_STATIC_BASE
  || (process.env.NODE_ENV === 'development' ? '/static' : 'http://36.139.201.194:90/static')
)

const API_UPLOAD_BASE = normalizeBaseUrl(
  process.env.VUE_APP_UPLOAD_PUBLIC_BASE
  || (process.env.NODE_ENV === 'development' ? '/api/uploads' : 'http://36.139.201.194:90/api/uploads')
)

function toStaticUrl(path) {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  if (path.startsWith('/')) return path
  if (/^uploads\//i.test(path)) {
    return joinUrl(API_UPLOAD_BASE, path.replace(/^uploads\/+/i, ''))
  }
  return joinUrl(STATIC_BASE, normalizeUploadPath(path))
}

async function upload(path, formData, fallbackMessage) {
  const response = await requestRaw(path, {
    method: 'POST',
    body: formData
  })
  const result = await response.json().catch(() => ({}))

  if (!response.ok) {
    const errMsg = result.message || result.msg || fallbackMessage || `上传失败 ${response.status}`
    const err = new Error(errMsg)
    err.status = response.status
    err.data = result
    throw err
  }

  return result
}

export async function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)

  const result = await upload('/api/upload', formData, '上传失败')
  const item = extractUploadedItems(result)[0]
  const path = extractUploadedPath(item)

  if (!path) {
    throw new Error(result.message || result.msg || '上传成功但未返回文件路径')
  }

  return path
}

export async function uploadFiles(files = []) {
  const fileList = Array.isArray(files) ? files.filter(Boolean) : []
  if (!fileList.length) return []

  const formData = new FormData()
  if (fileList.length === 1) {
    formData.append('file', fileList[0])
  } else {
    fileList.forEach((file) => formData.append('files', file))
  }

  const result = await upload('/api/upload', formData, '上传失败')
  const paths = extractUploadedItems(result)
    .map((item) => extractUploadedPath(item))
    .filter(Boolean)

  if (!paths.length) {
    throw new Error(result.message || result.msg || '上传成功但未返回文件路径')
  }

  return paths
}

export function getImageUrl(path) {
  return toStaticUrl(path)
}

export function getPublicImageUrl(path) {
  return toStaticUrl(path)
}
